import Footer24 from '@/components/organisms/Footer24';
import Header24 from '@/components/organisms/Header24';
import BancoDoAuto25Banner from '@/components/organisms/BancoDoAuto25Banner';
import { BancoDoAutoTabs } from '@/data/misc/banco-do-auto-tabs';
import React, { useState } from 'react';
import CustomTabs from '../CustomTabs';
import BancoDoAuto25 from '@/components/templates/BancoDoAuto25';
import FinanciamentoDeMotos25 from '@/components/templates/FinanciamentoDeMotos25';
import FinanciamentoDePesados25 from '@/components/templates/FinanciamentoDePesados25';
import BancoDoAutoMoto25Banner from '@/components/organisms/BancoDoAutoMoto25Banner';
import BancoDoAutoPesado25Banner from '@/components/organisms/BancoDoAutoPesado25Banner';
import Styles from './TabGroupBancoDoAuto.css';
import BancoDoAuto25BannerAbr26 from '@/components/organisms/BancoDoAuto25BannerAbr26';
import BancoDoAutoMotoBannerRCF from '@/components/organisms/BancoDoAutoMotoBannerRCF';
import BancoDoAuto25BannerAgo26 from '@/components/organisms/BancoDoAuto25BannerAgo26';

function TabGroupBancoDoAuto({ tab }) {
  const [currentTab, setCurrentTab] = useState(tab);

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  return (
    <>
      <Header24 />

      {currentTab === BancoDoAutoTabs['banco-do-auto'].id && (
        <>
          {/* <BancoDoAuto25Banner /> */}
          {/* <BancoDoAuto25BannerAbr26 /> */}
          <BancoDoAuto25BannerAgo26 />
        </>
      )}
      {currentTab === BancoDoAutoTabs['financiamento-de-motos'].id && (
        <>
          {/* <BancoDoAutoMoto25Banner /> */}
          <BancoDoAutoMotoBannerRCF />
        </>
      )}
      {currentTab === BancoDoAutoTabs['financiamento-de-pesados'].id && (
        <>
          <BancoDoAutoPesado25Banner />
        </>
      )}

      <CustomTabs initialTab={tab} tabs={BancoDoAutoTabs} onTabChanged={handleTab} />

      {currentTab === BancoDoAutoTabs['banco-do-auto'].id && (
        <>
          <BancoDoAuto25 />
        </>
      )}
      {currentTab === BancoDoAutoTabs['financiamento-de-motos'].id && (
        <>
          <FinanciamentoDeMotos25 />
        </>
      )}
      {currentTab === BancoDoAutoTabs['financiamento-de-pesados'].id && (
        <>
          <FinanciamentoDePesados25 />
        </>
      )}

      {/* <BancoDoAutoConteudoBlog /> */}
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupBancoDoAuto;
